module.exports = __webpack_public_path__ + "static/media/vg.672b07c4.svg";